// Resolve legacy public links before Angular's initial navigation can activate
// the authenticated root route. Never interpret an arbitrary hash as a URL.
export function publicHashEntryUrl(href: string): string | null {
  const current = new URL(href);
  if (current.searchParams.has("code") || current.searchParams.has("state") || current.searchParams.has("error")) {
    return null;
  }
  const path = current.hash.substring(1);
  if (!/^\/(?:join\/|public-event-invite\/|i\/|claim\/|profile\/|guest-upgrade(?:[/?#]|$)|guest-manager(?:[/?#]|$)|email-verified(?:[/?#]|$))/.test(path)) {
    return null;
  }
  const target = new URL(path, current.origin);
  if (target.origin !== current.origin) {
    return null;
  }
  current.searchParams.forEach((value, key) => {
    if (!target.searchParams.has(key)) {
      target.searchParams.set(key, value);
    }
  });
  return target.pathname + target.search + target.hash;
}
